import { organizationsWhere, type OrganizationMembership } from "@nabble/sdk";
import { Field, Select } from "@nabble/ui";
import { useMemo, useState } from "react";
import { useAuth } from "../auth/AuthContext";

/**
 * The organization the section is managing: the selected one when the person administers it,
 * otherwise the first one they administer in view. With several (combined view) a picker shows.
 */
export function useManagedOrganization(): {
  managed: OrganizationMembership[];
  organizationId: string | null;
  picker: React.ReactNode;
} {
  const { user } = useAuth();
  const managed = useMemo(() => organizationsWhere(user, "core.organization"), [user]);
  const fallback = managed.find((o) => o.id === user?.organization?.id)?.id ?? managed[0]?.id ?? null;
  const [chosen, setChosen] = useState<string | null>(null);
  const organizationId = chosen && managed.some((o) => o.id === chosen) ? chosen : fallback;

  const picker =
    managed.length > 1 ? (
      <div className="nb-org-picker">
        <Field label="Organization">
          <Select value={organizationId ?? ""} onValueChange={setChosen} options={managed.map((o) => ({ value: o.id, label: o.name }))} />
        </Field>
      </div>
    ) : null;

  return { managed, organizationId, picker };
}
